import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { ApiError, errorMessage } from './problem';

/** Shows problem+json `detail` as a toast. 401s are handled by the auth layer and are not toasted. */
export function notifyError(err: unknown): void {
  if (err instanceof ApiError && err.status === 401) return;
  toast.error(errorMessage(err));
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: (err, query) => {
        if (query.meta?.['silent'] !== true) notifyError(err);
      },
    }),
    mutationCache: new MutationCache({
      onError: (err, _vars, _ctx, mutation) => {
        if (mutation.meta?.['silent'] !== true) notifyError(err);
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        refetchOnWindowFocus: false,
        retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2,
      },
    },
  });
}
